import React, { forwardRef } from 'react';
import styles from './Skeleton.module.css';

/** forward runs left to right, reverse right to left; sweep is a diagonal glint across its parent. */
export type SkeletonShimmer = 'forward' | 'reverse' | 'sweep';
/** tint is the translucent white pair for content on a dark panel. */
export type SkeletonTone = 'default' | 'tint';

export interface ISkeletonProps extends React.HTMLAttributes<HTMLSpanElement> {
  shimmer?: SkeletonShimmer;
  /** Ignored by sweep. */
  tone?: SkeletonTone;
  /** Ignored by sweep. */
  square?: boolean;
}

const Skeleton = forwardRef<HTMLSpanElement, ISkeletonProps>(
  ({ shimmer = 'forward', tone = 'default', square = false, className, ...rest }, ref) => {
    const block = shimmer !== 'sweep';
    const classes = [
      styles.skeleton,
      styles[shimmer],
      block && tone === 'tint' && styles.tint,
      block && square && styles.square,
      className,
    ];

    return (
      <span ref={ref} aria-hidden="true" className={classes.filter(Boolean).join(' ')} {...rest} />
    );
  },
);

Skeleton.displayName = 'Skeleton';

export default Skeleton;
